import { ElementType, ReactNode } from "react";

import { Typography } from "@mui/material";

const BOLD_PATTERN = /\*\*(.+?)\*\*/g;

interface Props {
  text: string;
  /** Pass "span" when rendering inside a paragraph — a block element would close it early. */
  component?: ElementType;
}

export function FormattedText({ text, component = "div" }: Props) {
  return (
    <Typography variant="body2" component={component} sx={{ whiteSpace: "pre-line" }}>
      {renderWithBold(text)}
    </Typography>
  );
}

function renderWithBold(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(BOLD_PATTERN)) {
    const start = match.index;
    if (start > lastIndex) {
      nodes.push(text.slice(lastIndex, start));
    }
    nodes.push(<strong key={start}>{match[1]}</strong>);
    lastIndex = start + match[0].length;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes;
}
